<template>
	<div class="nomination_card_container">
	
	<div class="nomination_card">
		
		<div class="nomination_actions">

			<div class="container">
				<div class="row">
					<div class="col-8">
						
						<vue-bootstrap-typeahead
						v-model.trim="contest_nomination_text"
						placeholder="Type nomination..."
						:serializer="s => s.nomination_text"
						:data="nomination_suggestions"
						size="lg"
						inputClass="bod_input_field"
						backgroundVariant="info"
						textVariant="white"
						>
						</vue-bootstrap-typeahead>

					</div>
					<div class="col-4">
						
						<transition 
						name="" 
						mode="out-in"
						enter-active-class="animated tada faster" 
						leave-active-class="animated pulse faster" 
						>

							<!-- IF -->
							<button class="btn btn-primary" type="button" 
							:disabled="nomination_save_in_progress"
							:class="{disabled: nomination_save_in_progress}"
							@click="record_nomination"
							v-if="!save_status"
							key="nominate"
							>

								<span
								v-show="!nomination_save_in_progress"
								>
									Nominate
								</span>

								<span
								v-show="nomination_save_in_progress"
								>
									...
								</span>
								
							</button>
							<!-- END IF -->

							<!-- ELSE -->
							<button class="btn btn-success" type="button"
							@click="reset_nomination()"
							key="confirmation"
							v-else
							>
								<font-awesome-icon icon="check-circle"></font-awesome-icon>
							</button>
							<!-- END ELSE -->

						</transition>
						
					</div>
				</div>
			</div>

		</div>

		<!-- SOCIAL SHARE ROW -->
		<!-- <social-share-row></social-share-row> -->

		<!-- SHARE OPTIONS -->
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="nom_share_button">
						<b-button
						size="lg"
						variant="secondary"
						@click="goto_nom_share('/nominate', instance_contestid)"
						>
							Share
						</b-button>
					</div>
				</div>
			</div>
		</div>
		
		<!-- SPONSORSHIP BOX -->
		<sponsorship-box
		v-if="sponsor_list.length > 0"
		title="This contest sponsored by:"
		:sponsors="sponsor_list"
		></sponsorship-box>

	</div>

	</div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import SponsorshipBox from '@/features/sponsorships/sponsorship_box.vue';
import SocialShareRow from '@/components/social/social_share_row.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faCheckCircle);

export default {
	name: 'NominationCard',
	props: [
		'instance_contestid',
		'nomination_save_status',
		'nomination_save_in_progress',
		'reset_nomination_requested'
	],
	data () {
		return {
			contest_nomination_text: '',
			save_status: this.nomination_save_status
		}
	},
	created() {
		this.$root.store.contests.get_contest_sponsors(this.instance_contestid);
		this.$root.store.nominations.get_nomination_suggestions_by_contest(this.instance_contestid);
	},
	watch: {
		nomination_save_status: function(new_val, old_val) {
			let vm = this;

			vm.$set(vm, 'save_status', new_val);
		},
		reset_nomination_requested: function(new_val, old_val) {
			let vm = this;

			if(new_val === true) {
				vm.reset_nomination();
			}
		}
	},
	computed: {
		sponsor_list: function() {
			return this.$root.store.contests.get_current_contest_sponsors(this.instance_contestid);
		},
		nomination_suggestions: function() {
			return this.$root.store.nominations.get_current_nomination_suggestions_by_contest(this.instance_contestid);
		}
	},
	methods: {
		reset_nomination: function() {
			this.contest_nomination_text = '';
			this.$emit('request_nomination_reset', '');
		},
		record_nomination: function() {
			let vm = this;

			if(vm.contest_nomination_text != '') {
				vm.$emit('record_nomination_from_contest', vm.contest_nomination_text);
			}
		},
		goto_nom_share: function(path_name, param) {
			// TOGGLE NOM SHARE STATUS TO TRUE
			this.$root.store.nominations.change_single_nom_share_status(true);

			// GOTO SINGLE NOM
			this.goto_path(path_name, param);
		},
		goto_path: function(path_name, param) {
			this.$root.store.goto_path(path_name, param);
		}
	},
	components: {
		VueBootstrapTypeahead,
		SponsorshipBox,
		SocialShareRow
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.button-enter {
	opacity: 0;
}

.nomination_card {

	.nomination_actions {
		padding: 1em 0;
	}

	.btn, input {
		width: 100%;
		height: 100%;
	}

	.btn {
		
	}

	.sponsorship_box_container {
		margin-bottom: 1em;
	}

	.nom_share_button {
		padding: 1em 0;

		button {
			text-transform: uppercase;
		}
	
	}
}
</style>



// WEBPACK FOOTER //
// src/features/nominate/nominate_card.vue